module.exports = __webpack_public_path__ + "img/logoH.9f9db492.svg";